export enum ServerZone {
  US = 'US',
  EU = 'EU',
}
